export * from './document-pending.component';
